import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2, Mail, Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin/dashboard", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(identifier.trim(), password);
    setLoading(false);
    if (res.ok) navigate("/admin/dashboard", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-sm p-8">
        <div className="flex flex-col items-center text-center mb-7">
          <img src="/logo-proam.jpg" alt="PROAM Venezuela" className="w-full max-w-[240px] h-auto mb-4" />
          <h1 className="font-heading text-2xl font-bold text-slate-900">Panel de administración</h1>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block font-medium text-slate-800 mb-1.5">Correo o usuario</label>
            <div className="relative">
              <Mail className="absolute left-3.5 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
              <input type="text" value={identifier} onChange={(e) => setIdentifier(e.target.value)} data-testid="admin-email" required
                className="w-full h-12 pl-11 pr-4 rounded-lg border border-slate-300 bg-white outline-none focus:ring-4 focus:ring-orange-200 focus:border-orange-600" />
            </div>
          </div>
          <div>
            <label className="block font-medium text-slate-800 mb-1.5">Contraseña</label>
            <div className="relative">
              <Lock className="absolute left-3.5 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400" />
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required
                className="w-full h-12 pl-11 pr-4 rounded-lg border border-slate-300 bg-white outline-none focus:ring-4 focus:ring-orange-200 focus:border-orange-600" />
            </div>
          </div>
          {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit"
            className="w-full h-12 rounded-lg bg-orange-600 text-white font-semibold hover:bg-orange-700 transition-colors disabled:opacity-60 flex items-center justify-center">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Iniciar sesión"}
          </button>
        </form>
        <p className="text-center text-sm text-slate-400 mt-6">
          <a href="/" className="text-orange-600 font-medium">← Volver al formulario de registro</a>
        </p>
      </div>
    </div>
  );
}
